import React from 'react';
import { connect } from 'react-redux'
import { choosePhoto, unchoosePhoto } from 'components/collage/CollageSlice.js'

// CSS
import './SelectablePhoto.css';

class SelectablePhoto extends React.Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.collage.photos.chosenNodes[this.props.src] != nextProps.collage.photos.chosenNodes[this.props.src];
  }

  handleClick = () => {

    // If it's already selected, deselect on press.
    if ( this.props.collage.photos.chosenNodes[this.props.src] ) {
      this.props.unchoosePhoto(this.props.src);
    }
    else {
      this.props.choosePhoto({
        src: this.props.src,
        photo: this.props.photo
      });
    }
  }

  render() {
    let className = 'SelectablePhoto' + (this.props.collage.photos.chosenNodes[this.props.src] ? ' SelectablePhoto--Selected' : '');

    let imgStyle;
    if ( this.props.photo.isPortrait) {
      imgStyle = {
        width: '100%' ,
        height: (100 * this.props.photo.ratio) + '%',
        top: '50%',
        transform: 'translateY(-50%)'
      }
    }
    else {
      imgStyle = {
        width: (100 * this.props.photo.ratio) + '%',
        height: '100%',
        transform: 'translateX(-50%)',
        left: '50%'
      }
    }

    // console.log('this.props.ratio: ' + this.props.photo.ratio);
    return (
      <button 
        className={className}
        onClick={this.handleClick}
        // style={{
        //   backgroundColor: '#' + Math.floor(Math.random()*16777215).toString(16)
        // }}
      >
        <img src={this.props.photo.src} style={imgStyle}  />
      </button>
    );
  }
}
const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  { choosePhoto, unchoosePhoto }
)(SelectablePhoto)